import ForgotPassword from '../components/home/forgotPassword/ForgotPassword'
import ResetPassword from '../components/home/forgotPassword/ResetPassword'
import Login from '../components/home/login/Login'
import Register from '../components/home/register/Register'

const AuthModal = ({ handleAuth, openReg, openAuth, setOpenAuth }) => {
  return (
    <>
      {openReg && openAuth === 'register' ? (
        <Register handleAuth={handleAuth} setOpenAuth={setOpenAuth} />
      ) : openAuth === 'login' ? (
        <Login handleAuth={handleAuth} setOpenAuth={setOpenAuth} />
      ) : openAuth === 'resetPassword' ? (
        <ResetPassword handleAuth={handleAuth} setOpenAuth={setOpenAuth} />
      ) : (
        <ForgotPassword handleAuth={handleAuth} setOpenAuth={setOpenAuth} />
      )}
    </>
  )
}
export default AuthModal
